/**
 * Flattens a GraphQL edges->node array into an array of objects
 *
 * @param edges
 * @returns {Array}
 */
export default (edges: Array<any>) => {
  const arr: Array<any> = [];
  for (const edge of edges) {
    arr.push(edge.node);
  }

  return arr;
};
